<div class="table-editor-container">
  <div class="editor-header">
    <div class="header-content">
      <button class="back-button" (click)="onCancel()">
        <mat-icon>arrow_back</mat-icon>
        Back to Tables
      </button>
      <div class="title-section">
        <h2>{{ isEditMode ? 'Edit Table' : 'Create New Table' }}</h2>
      </div>
    </div>
  </div>

    <form [formGroup]="tableForm" class="table-form">
    <!-- Compact Table Info Row -->
    <div class="compact-form-row">
      <!-- Table Name -->
      <div class="form-field name-field">
        <label for="tableName">Table Name *</label>
        <input
          id="tableName"
          type="text"
          formControlName="tableName"
          placeholder="Enter table name"
          class="form-input"
          [class.error]="tableForm.get('tableName')?.invalid && tableForm.get('tableName')?.touched"
        />
        <div *ngIf="tableForm.get('tableName')?.invalid && tableForm.get('tableName')?.touched" class="error-message">
          Table name is required
        </div>
      </div>

      <!-- Table Description -->
      <div class="form-field description-field">
        <label for="tableDescription">Description</label>
        <input
          id="tableDescription"
          type="text"
          formControlName="tableDescription"
          placeholder="Enter table description (optional)"
          class="form-input"
        />
      </div>

      <!-- Checkboxes -->
      <div class="form-field checkboxes-field">
        <div class="checkbox-group">
          <label class="checkbox-label">
            <input
              type="checkbox"
              formControlName="isShared"
              class="checkbox-input"
            />
            <span class="checkbox-text">Share</span>
          </label>
          <label class="checkbox-label">
            <input
              type="checkbox"
              formControlName="isDefault"
              class="checkbox-input"
            />
            <span class="checkbox-text">Default</span>
          </label>
        </div>
      </div>
    </div>

        <!-- Shared To (only show if isShared is true) -->
    <div class="form-field" *ngIf="tableForm.get('isShared')?.value">
      <label for="sharedTo">Shared With</label>
      <input
        id="sharedTo"
        type="text"
        [(ngModel)]="sharedToInput"
        [ngModelOptions]="{standalone: true}"
        (input)="onSharedToInputChange($event)"
        placeholder="Enter email addresses separated by commas, or 'GLOBAL' to share with everyone"
        class="form-input"
      />
      <div class="help-text">
        Enter email addresses separated by commas, or type "GLOBAL" to share with everyone
      </div>
    </div>

    <!-- Space for creation section -->
    <div class="creation-section-spacer">
      <div *ngIf="loadingData" class="loading-indicator">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Loading datasets and metrics...</span>
      </div>
            <div *ngIf="!loadingData" class="creation-section-content">
        <!-- Compact Selection Row -->
        <div class="selection-row">
          <div class="selection-item">
            <label>Dataset</label>
            <mat-form-field appearance="outline">
                            <mat-select
                placeholder="Select dataset"
                [(ngModel)]="selectedDataset"
                [ngModelOptions]="{standalone: true}"
                (selectionChange)="onDatasetSelect($event)"
              >
                <mat-option *ngFor="let dataset of datasets" [value]="dataset">
                  {{ dataset.datasetReferenceTable.datasetName }} ({{ getDatasetColumns(dataset).length }} columns)
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="selection-item">
            <label>Metric</label>
            <mat-form-field appearance="outline">
                            <mat-select
                placeholder="Select metric"
                [(ngModel)]="selectedMetric"
                [ngModelOptions]="{standalone: true}"
                (selectionChange)="onMetricSelect($event)"
              >
                <mat-option *ngFor="let metric of metrics" [value]="metric">
                  {{ metric.metricName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Workspace -->
        <div class="workspace">
          <div class="workspace-header">
            <div class="workspace-title">
              <h3>Database Workspace</h3>
              <div class="selection-info" *ngIf="selectedFields.size > 0">
                <span class="selected-count">{{ selectedFields.size }} field{{ selectedFields.size !== 1 ? 's' : '' }} selected</span>
                <button class="clear-selections-btn" (click)="clearAllSelections()">
                  <mat-icon>clear</mat-icon>
                  Clear All
                </button>
              </div>
            </div>

            <div class="workspace-info">
              <span class="scroll-hint">Click fields to select • Connected fields only • Drag tables to position</span>
            </div>
          </div>

                     <!-- Table Preview Header -->
         <div class="table-preview" *ngIf="getSelectedColumnsData().length > 0">
           <div class="preview-header">
             <h4>Table Preview</h4>
             <span class="preview-subtitle">Selected columns for your table (drag to reorder)</span>
           </div>
           <div class="table-headers-container">
                     <div
          *ngFor="let col of getSelectedColumnsData(); let i = index"
          class="table-header-item">
          <div class="column-controls">
            <button
              class="move-btn"
              [disabled]="i === 0"
              (click)="moveColumnLeft(i)"
              title="Move column left">
              <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <button
              class="move-btn"
              [disabled]="i === getSelectedColumnsData().length - 1"
              (click)="moveColumnRight(i)"
              title="Move column right">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </div>
          <input
            type="text"
            class="column-name-input"
            [value]="col.name"
            (blur)="updateColumnName(i, $any($event.target).value)"
            (keyup.enter)="$any($event.target).blur()"
            title="Click to edit column name">
          <button
            class="remove-column-btn"
            (click)="removeColumnByIndex(i)"
            title="Remove column">
            ×
          </button>
        </div>
           </div>
         </div>
              <div class="workspace-container"
               (dragover)="onTableDragOver($event)"
               (drop)="onTableDrop($event)">

            <!-- Connection Arrows -->
            <svg class="connections-layer" width="100%" height="100%">
              <defs>
                <marker id="arrowhead" markerWidth="8" markerHeight="6"
                        refX="7" refY="3" orient="auto">
                  <polygon points="0 0, 8 3, 0 6" fill="#1976d2" />
                </marker>
              </defs>
              <g *ngFor="let connection of tableConnections">
                <line
                  [attr.x1]="connection.fromX"
                  [attr.y1]="connection.fromY"
                  [attr.x2]="connection.toX"
                  [attr.y2]="connection.toY"
                  stroke="#1976d2"
                  stroke-width="2"
                  marker-end="url(#arrowhead)"
                  class="connection-line"
                />
              </g>
            </svg>

            <div *ngIf="workspaceTablesWithPosition.length === 0" class="empty-workspace">
              <mat-icon>table_chart</mat-icon>
              <p>Select a dataset above to start building your table</p>
            </div>

                        <bhub-dataset-field
              *ngFor="let tableData of workspaceTablesWithPosition; let i = index"
              [dataset]="tableData.dataset"
              [x]="tableData.x"
              [y]="tableData.y"
              [zIndex]="tableData.zIndex"
              [index]="i"
              [fieldPositions]="fieldPositions"
              [selectedFields]="selectedFields"
              [getConnectionType]="getFieldConnectionType.bind(this)"
              (dragStart)="onTableDragStart($event.event, $event.index)"
              (remove)="removeDatasetFromWorkspace($event)"
              (fieldClick)="onFieldClick($event.tableIndex, $event.fieldName)">
            </bhub-dataset-field>

            <!-- Metric Boxes -->
            <bhub-metric-field
              *ngFor="let metricData of workspaceMetricsWithPosition; let i = index"
              [metric]="metricData.metric"
              [x]="metricData.x"
              [y]="metricData.y"
              [zIndex]="metricData.zIndex"
              [index]="i"
              [selectedFields]="selectedFields"
              (dragStart)="onMetricDragStart($event.event, $event.index)"
              (remove)="removeMetricFromWorkspace($event)"
              (metricClick)="onMetricClick($event.metricIndex, $event.metricName)">
            </bhub-metric-field>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="form-actions">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="onCancel()"
      >
        Cancel
      </button>
      <div class="save-validation" *ngIf="!isFormValid">
        <mat-icon>info</mat-icon>
        <span *ngIf="!tableForm.valid">Please enter a table name</span>
        <span *ngIf="tableForm.valid && tableColumnDefinitions.length === 0">Please select at least one column to create a table</span>
      </div>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!isFormValid || isSaving"
        (click)="onSave()"
      >
        <mat-spinner *ngIf="isSaving" diameter="16" class="save-spinner"></mat-spinner>
        <span *ngIf="!isSaving">{{ isEditMode ? 'Update Table' : 'Create Table' }}</span>
        <span *ngIf="isSaving">Creating...</span>
      </button>
    </div>
  </form>
</div>
